import { createRouter, createWebHistory } from 'vue-router';
//
// console.log(VueRouter);
/**
 * fix Uncaught (in promise) Error: Avoided redundant navigation to current location
 * * */

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location, onComplete, onAbort) {
// 	const result = originalPush.call(
// 		this,
// 		location,
// 		onComplete,
// 		onAbort
// 	);
// 	if (result) {
// 		return result.catch(err => {
// 			if (err.name !== 'NavigationDuplicated') {
// 				throw err;
// 			}
// 		});
// 	}
// 	return result;
// };
//
// const originalReplace = VueRouter.prototype.replace;
// VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
// 	const result = originalReplace.call(
// 		this,
// 		location,
// 		onComplete,
// 		onAbort
// 	);
// 	if (result) {
// 		return result.catch(err => {
// 			if (err.name !== 'NavigationDuplicated') {
// 				throw err;
// 			}
// 		});
// 	}
// 	return result;
// };
//
// /**
//  * router
//  */
//
// const router = new VueRouter({
// 	routes: require('./routes').default,
// 	mode: 'history',
// });
const router = createRouter({
  routes: require('./routes').default,
  history: createWebHistory(),
});

export default router;
// export default 12;
